
const UsedCarDetails =[

    { 
         name : "Suzuki Mehran",
         description :"Suzuki Mehran is available for just Rs 8 Lacs in best condition",
        pic:require("./images/mehran.jpg"),
        },
    
    {
         name : "Suzuki Alto",
         description :"Suzuki`s 2005 Alto japan varient for sale in 7Lacs",
        pic:require("./images/alto.jpg")
    },

    {
         name : "Hondai Santro",
         description :"Hondai Santro with amazing conditon for 5 LAcs",
        pic:require("./images/santro.jpg")
    },
 
    
    {
         name : "Toyota Corolla",
         description :"Toyota Corrola 2012 model only for Rs 16 Lac",
        pic:require("./images/corolaa.jpg")
    },

    
    {
        name : "Toyota Aqua",
        description :"Toyota Aqua hybrid model 2015 available for Rs 18 Lacs",
       pic:require("./images/aqua.jpg")
   },

   
   {
    name : "Suzuki Liana ",
    description :"Suzuki Liana model 2005 for sale at 8 Lacs",
   pic:require("./images/liana.jpg")
},


{
    name : "Suzuki Wagon R",
    description :"Suzuki Wagon R is available for sale at 17 Lacs model 2017",
   pic:require("./images/wagonr.jpg")
},


{
    name : "Toyota Vitz",
    description :"Toyota Vitz is available only in 15 Lacs",
   pic:require("./images/vitz.jpg")
},
    ]
    
export function getUsedCarDetails(){return UsedCarDetails;}
    
    
    